

import { useContext } from 'react'
import './footer.css'
import { LangContext } from '../../context/langContext/LangContext'
import { langData } from '../../langData'

function Footer() {
    const { lang } = useContext(LangContext)

    return (
        <footer id="footer">
            <div className="main-content">
                <div className="left box">
                    <div className="logo logo-wrap logo-footer">
                        <a href="#">
                            <img src="nwexpress.png" alt="NWExpress" />
                        </a>
                    </div>
                    <div className="content">
                        {langData[lang]["others"]["definition"]}
                    </div>
                </div>

                <div className="center box">
                    <h2>{langData[lang]["titles"]["contact_info"]}</h2>
                    <div className="content">
                        <div className="place">
                            <span style={{ marginRight: "10px" }} className="fas fa-map-marker-alt"></span>
                            <span className="text">{langData[lang]["others"]["adresse"]}</span>
                        </div>
                        <div className="phone">
                            <span style={{ marginRight: "10px" }} className="fas fa-phone-alt"></span>
                            <span className="text">+213 661 806 358</span>
                        </div>
                        <div className="email">
                            <span style={{ marginRight: "10px" }} className="fas fa-envelope"></span>
                            <span className="text">contact@nwexpress.dz</span>
                        </div>
                    </div>
                </div>

                <div className="right box">
                    <h2>{langData[lang]["titles"]["nos_reseaux_sociaux"]}</h2>
                    <div className="content">
                        <p>{langData[lang]["others"]["nous_trouver"]} :</p>
                        <div className="social">
                            <a href="#"><span className="fab fa-facebook-f"></span> </a>
                            <a href="#"><span className="fab fa-twitter"></span> </a>
                            <a href="#"><span className="fab fa-instagram"></span> </a>
                            <a href="#"><span className="fab fa-youtube"></span> </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bottom">
                <div className="center">
                    <span className="credit">{langData[lang]["others"]["created_by"]} <a href="#">NW Express</a> | </span>
                    <span className="far fa-copyright"></span>
                    <span>2025 {langData[lang]["others"]["all_rights_reserved"]}</span>
                </div>
            </div>
        </footer>
    )
}

export default Footer
